const ALLOWED_ENGAGE_HOSTS = new Set(["engage.toyota.com"]);

const isAllowedHostname = (hostname) => {
  const normalizedHostname = hostname?.toLowerCase();

  return Array.from(ALLOWED_ENGAGE_HOSTS).some((allowedHost) => {
    return (
      normalizedHostname === allowedHost ||
      normalizedHostname.endsWith(`.${allowedHost}`)
    );
  });
};

// Hosts this app is served from. Authored content links to them with absolute
// URLs (usually production's); those open in the app instead of reloading it.
// Other *.engage.toyota.com hosts are trusted but are separate apps.
const ENGAGE_APP_HOSTS = new Set([
  "engage.toyota.com",
  "www.engage.toyota.com",
  "staging.engage.toyota.com",
  "test.nonprod.engage.toyota.com",
  "dev.nonprod.engage.toyota.com",
]);

// Served by the host, not the router: hosted files, and anything ending in a
// file extension (no app route does).
const NOT_A_ROUTE =
  /(?:^\/(?:static|assets|api)(?:\/|$))|(?:\.[a-z0-9]{2,5}$)/i;

/**
 * The in-app path (pathname + search + hash) for a link the router can open,
 * or null for anything that must leave the app: other hosts, non-http schemes,
 * and files the host serves (PDFs, /static/…).
 */
export const toAppPath = (link) => {
  if (typeof link !== "string") {
    return null;
  }
  const trimmedLink = link.trim();
  if (!trimmedLink) {
    return null;
  }

  let url;
  try {
    // The current URL, not the origin, so `#section` and `?tab=b` stay on
    // this page.
    url = new URL(trimmedLink, window.location.href);
  } catch {
    return null;
  }

  const isRelative =
    trimmedLink.startsWith("/") && !trimmedLink.startsWith("//");
  const isAppHost =
    url.origin === window.location.origin ||
    ENGAGE_APP_HOSTS.has(url.hostname.toLowerCase());
  if (!/^https?:$/.test(url.protocol) || (!isRelative && !isAppHost)) {
    return null;
  }
  if (NOT_A_ROUTE.test(url.pathname)) {
    return null;
  }
  return `${url.pathname}${url.search}${url.hash}`;
};

export const isTrustedEngageUrl = (link) => {
  if (typeof link !== "string") {
    return false;
  }

  const trimmedLink = link.trim();

  if (trimmedLink.charAt(0) === "/") {
    return true;
  }

  try {
    const parsedUrl = new URL(trimmedLink);
    return isAllowedHostname(parsedUrl.hostname);
  } catch {
    return false;
  }
};
